import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2bef8ee7")
const _hoisted_1 = { class: "page card" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = { class: "p-d-flex p-ai-center" }
const _hoisted_5 = { class: "p-d-flex p-ai-center p-jc-center p-mb-3" }
const _hoisted_6 = { class: "p-my-0" }
const _hoisted_7 = { for: "is_active" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", { class: "p-text-center" }, "Gestione Tipologie Zona", -1)
const _hoisted_11 = { class: "p-d-flex p-jc-center" }
const _hoisted_12 = { class: "p-inputgroup" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_14 = { class: "p-fluid p-d-flex" }
const _hoisted_15 = { class: "p-field p-mr-3" }
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { class: "pi pi-eye" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-end" }, "Azioni", -1)
const _hoisted_19 = { class: "action_column" }
const _hoisted_20 = {
  class: "p-d-flex p-jc-between p-ai-center",
  style: {"width":"100%"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Mappa", -1)
const _hoisted_22 = { class: "manual_list" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Cliccare sul pulsante ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" dalla sezione ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", null, "Prezzi e costi aree", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("li", null, " Il cursore sopra la mappa assumerà questo aspetto: ✛ ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", null, " Individuare sulla mappa l'area desiderata e fare click. ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("li", null, " Comparirà un poligono e il livello dello zoom cambierà affinché sia ben visibile. ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("li", null, " Trascinare e modificare il poligono appena inserito. ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  style: {"height":"750px"}
}, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_VehicleAutocomplete = _resolveComponent("VehicleAutocomplete")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_ShiftCostsShortcut = _resolveComponent("ShiftCostsShortcut")!
  const _component_ShiftCosts = _resolveComponent("ShiftCosts")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_PDialog = _resolveComponent("PDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: _ctx.backRoute }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-arrow-left",
              class: "p-mb-0"
            }, null, 512), [
              [
                _directive_tooltip,
                _ctx.$t('back'),
                void 0,
                { bottom: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isEditName)
          ? (_openBlock(), _createBlock(_component_FloatLabel, {
              key: 0,
              label: _ctx.$t('zone.name')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  ref: "inputName",
                  modelValue: _ctx.zoneEdit.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.zoneEdit.name = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.isEditName = false), ["enter"])),
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEditName = false))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : (_openBlock(), _createElementBlock("h1", {
              key: 1,
              class: _normalizeClass({'p-text-secondary': !_ctx.zoneEdit.name}),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleEditName && _ctx.toggleEditName(...args)))
            }, _toDisplayString(_ctx.zoneEdit.name ? _ctx.zoneEdit.name : _ctx.$t('zone.name')), 3)),
        _createVNode(_component_Button, {
          class: _normalizeClass(["p-ml-3", _ctx.isEditName ? 'p-button-success' : 'p-button-warning']),
          icon: `pi ${_ctx.isEditName ? 'pi-check' : 'pi-pencil'}`,
          onClick: _ctx.toggleEditName
        }, null, 8, ["class", "icon", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-mr-1",
          onClick: _ctx.onSave,
          disabled: _ctx.requestPending
        }, null, 8, ["onClick", "disabled"]), [
          [
            _directive_tooltip,
            _ctx.$t('common.save'),
            void 0,
            { bottom: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_InputSwitch, {
        id: "is_active",
        modelValue: _ctx.zoneEdit.is_active,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.zoneEdit.is_active = $event)),
        class: "p-mr-2"
      }, null, 8, ["modelValue"]),
      _createElementVNode("h4", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, [
          (_ctx.zoneEdit.is_active)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('zone.active')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('zone.disabled')), 1))
        ])
      ])
    ]),
    _createVNode(_component_Accordion, {
      multiple: true,
      activeIndex: _ctx.activeIndexes,
      "onUpdate:activeIndex": _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeIndexes = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "Prezzi e costi per tipologia" }, {
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_VehicleAutocomplete, {
                    ids: _ctx.selectedVehicleIds,
                    onSelect: _ctx.onSelect
                  }, null, 8, ["ids", "onSelect"])
                ])
              ]),
              _createVNode(_component_DataTable, {
                value: _ctx.zoneEdit.vehicle_data,
                class: "p-mt-3",
                "auto-layout": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "vehicle.name_it",
                    header: "Nome tipologia"
                  }, {
                    body: _withCtx(({data}) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("i", {
                          class: _normalizeClass(`p-mr-2 fas fa-${data.vehicle.icon}`)
                        }, null, 2),
                        _createElementVNode("span", null, _toDisplayString(data.vehicle.name_it), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "extra_price",
                    header: "Prezzo extra"
                  }, {
                    body: _withCtx(({data}) => [
                      _createVNode(_component_FloatLabel, { label: "Prezzo extra" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputNumber, {
                            modelValue: data.extra_price,
                            "onUpdate:modelValue": ($event: any) => (data.extra_price = $event),
                            mode: "currency",
                            currency: "EUR"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "extra_cost",
                    header: "Costo extra"
                  }, {
                    body: _withCtx(({data}) => [
                      _createVNode(_component_FloatLabel, { label: "Costo extra" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputNumber, {
                            modelValue: data.extra_cost,
                            "onUpdate:modelValue": ($event: any) => (data.extra_cost = $event),
                            mode: "currency",
                            currency: "EUR"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "is_enabled",
                    header: "Attivo"
                  }, {
                    body: _withCtx(({data}) => [
                      _createVNode(_component_InputSwitch, {
                        class: "p-mr-3",
                        modelValue: data.is_enabled,
                        "onUpdate:modelValue": ($event: any) => (data.is_enabled = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { class: "column-header-right p-text-right" }, {
                    body: _withCtx(({data}) => [
                      _createVNode(_component_DeleteButton, {
                        onClick: ($event: any) => (_ctx.removeVehicle(data)),
                        title: "rimuovi tipologia"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "Fasce orarie e costi" }, {
          default: _withCtx(() => [
            _createVNode(_component_ShiftCostsShortcut, { onSubmit: _ctx.onShortcutSubmit }, null, 8, ["onSubmit"]),
            _createVNode(_component_Accordion, null, {
              default: _withCtx(() => [
                _createVNode(_component_AccordionTab, { header: "Dettaglio per fascia" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ShiftCosts, { zoneEdit: _ctx.zoneEdit }, null, 8, ["zoneEdit"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "Prezzi Costi Aree" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_FloatLabel, { label: "Prezzo al Km" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      modelValue: _ctx.zoneEdit.price_km_flat,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.zoneEdit.price_km_flat = $event)),
                      mode: "currency",
                      currency: "EUR",
                      class: "small_input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_FloatLabel, {
                  label: "Costo al Km",
                  class: "p-field"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      modelValue: _ctx.zoneEdit.cost_km_flat,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.zoneEdit.cost_km_flat = $event)),
                      mode: "currency",
                      currency: "EUR",
                      class: "small_input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_DataTable, {
              value: _ctx.zoneEdit.shapes,
              responsiveLayout: "scroll"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "name",
                  header: "Nome"
                }, {
                  body: _withCtx(({data}) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", `badge--color${data.idx}`]),
                      style: _normalizeStyle({color: _ctx.colors[data.idx-1]})
                    }, _toDisplayString(data.name), 7)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Prezzo" }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_InputNumber, {
                      modelValue: data.price,
                      "onUpdate:modelValue": ($event: any) => (data.price = $event),
                      mode: "currency",
                      currency: "EUR",
                      placeholder: "##.## €"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Costo" }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_InputNumber, {
                      modelValue: data.cost,
                      "onUpdate:modelValue": ($event: any) => (data.cost = $event),
                      mode: "currency",
                      currency: "EUR",
                      placeholder: "##.## €"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Attiva" }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Checkbox, {
                      modelValue: data.isActive,
                      "onUpdate:modelValue": ($event: any) => (data.isActive = $event),
                      onChange: ($event: any) => (_ctx.onActiveChange(data)),
                      binary: true
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  class: "p-text-center",
                  headerClass: "column-header-center"
                }, {
                  header: _withCtx(() => [
                    _withDirectives(_createElementVNode("i", _hoisted_17, null, 512), [
                      [
                        _directive_tooltip,
                        _ctx.$t('show_hide'),
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Checkbox, {
                      modelValue: data.isVisible,
                      binary: true,
                      onClick: ($event: any) => (_ctx.toggleVisibility(data))
                    }, null, 8, ["modelValue", "onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { headerClass: "column-header-right" }, {
                  header: _withCtx(() => [
                    _hoisted_18
                  ]),
                  body: _withCtx(({data}) => [
                    _createElementVNode("div", _hoisted_19, [
                      (_ctx.isDrawing && _ctx.isDrawing === data.idx)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            tabindex: "-1",
                            class: "p-button-secondary p-ml-1",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.stopDrawShape()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_FaIcon, { icon: "times" })
                            ]),
                            _: 1
                          }, 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('cancel'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.showDrawButton(data))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            tabindex: "-1",
                            disabled: _ctx.isDrawing,
                            class: "p-button-icon-only p-ml-1",
                            onClick: ($event: any) => (_ctx.drawShape(data.idx))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_FaIcon, { icon: "paint-brush" })
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('draw'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_Button, {
                        tabindex: "-1",
                        class: "p-button-outlined p-button-danger p-ml-1",
                        onClick: ($event: any) => (_ctx.restore(data))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_FaIcon, { icon: "eraser" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t('to_empty'),
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      (data.polygonRef)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 2,
                            tabindex: "-1",
                            class: "p-button-danger p-ml-1",
                            onClick: ($event: any) => (_ctx.deleteShape(data))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_FaIcon, { icon: "trash-alt" })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('delete'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "pi pi-question-circle",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleManual && _ctx.toggleManual(...args)), ["stop"]))
                }),
                _createVNode(_component_PDialog, {
                  visible: _ctx.showManual,
                  "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.showManual = $event)),
                  position: "right",
                  header: "Istruzioni",
                  style: {
                  minWidth: '320px', 
                  width: '50vw', 
                  maxWidth: '600px'
                },
                  modal: true,
                  dismissableMask: true,
                  draggable: false,
                  keepInViewPort: true,
                  minX: 0,
                  minY: 0
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_22, [
                      _createElementVNode("li", null, [
                        _hoisted_23,
                        _createVNode(_component_Button, { class: "p-button-icon-only p-mx-1" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FaIcon, { icon: "paint-brush" })
                          ]),
                          _: 1
                        }),
                        _hoisted_24,
                        _hoisted_25
                      ]),
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeIndex"])
  ]))
}